import * as React from 'react';

export type PopperArrowType = [
  React.Dispatch<React.SetStateAction<string | HTMLElement | null | undefined>>,
  React.CSSProperties
];

export const popperArrowContext = React.createContext<PopperArrowType | null>(null);
